import { Formik } from 'formik';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';

import AutoSave from '@components/AutoSave';
import { ImageFieldWithAvatar } from '@components/FormFields';
import { useProfileUpdate } from '@hooks';

import ProfileImageSchema from './ProfileImageSchema';

interface ProfileImageProps {
  profileImage: string;
  userId: number;
}

const ProfileImage = ({ userId, profileImage }: ProfileImageProps) => {
  const initialState = useMemo(
    () => ({
      profileImage: profileImage || [],
    }),
    [profileImage]
  );

  const { saveProfile, showSave, saveStatus } = useProfileUpdate(userId);

  const handleSubmit = ({ profileImage }) => {
    if (typeof profileImage === 'string') return;
    const sanitizedParams = { picture: profileImage, withImage: true };
    saveProfile(sanitizedParams);
  };

  return (
    <Formik
      initialValues={initialState}
      onSubmit={handleSubmit}
      validationSchema={ProfileImageSchema}
    >
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <AutoSave debounceMs={500} />
          {showSave && (
            <div
              className={`save-label-img ${
                saveStatus === 'Saved' || saveStatus === 'Saving' ? 'success' : 'failure'
              }`}
            >
              {saveStatus}
            </div>
          )}
          <div className="image-container">
            <ImageFieldWithAvatar name="profileImage" />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ProfileImage;
